import {
  collection,
  CollectionReference,
  doc,
  FieldValue,
  getDoc,
  onSnapshot,
  query,
  QuerySnapshot,
  setDoc,
  updateDoc,
  where,
  orderBy
} from 'firebase/firestore'
import { firestore } from '@/modules/firebase'

type UserUpdateData = Omit<Partial<User>, 'consumedNews' | 'preferences'> & {
  consumedNews?: FieldValue
} & Record<`preferences.${keyof UserPreferences}${string}`, any>

const userCollection = collection(
  firestore,
  'users'
) as CollectionReference<User>

const getUserNewsCollection = (userId: string) => {
  return collection(
    userCollection,
    userId,
    'news'
  ) as CollectionReference<UserFeedEntry>
}

export async function createUser(user: User) {
  return setDoc(doc(userCollection, user.id), user)
}

export async function getUser(userId: string) {
  const snapshot = await getDoc(doc(userCollection, userId))
  const userData = snapshot.data()
  if (userData) {
    return userData
  } else throw new Error('No matching document found') // TODO: Consolidate errors
}

export async function updateUser(userId: string, updateData: UserUpdateData) {
  const userRef = doc(userCollection, userId)
  return updateDoc(userRef, updateData)
}

export async function getUsers(userIds: string[]) {
  const userDocs = await Promise.all(
    userIds.map((userId) => {
      return getUser(userId)
    })
  )
  return userDocs.sort((userA, userB) => {
    const lastNameA = userA?.lastName || ''
    const lastNameB = userB?.lastName || ''
    return lastNameA.localeCompare(lastNameB)
  })
}

export function getFeedListener(
  userId: string,
  onNext: (snapshot: QuerySnapshot<UserFeedEntry>) => void
) {
  const feedQuery = query(
    getUserNewsCollection(userId),
    where('isConsumed', '==', false),
    orderBy('timestamp', 'desc')
  )
  return onSnapshot(feedQuery, onNext)
}

export async function updateFeedEntry(
  userId: string,
  newsId: string,
  updateData: Partial<UserFeedEntry>
) {
  const feedEntryRef = doc(getUserNewsCollection(userId), newsId)
  return updateDoc(feedEntryRef, updateData)
}
